/**
 * Central registry for all UserState key names.
 * Use these constants everywhere instead of inline strings to prevent typos.
 */
export const UserStateKeys = {
    yourNoteActiveTopicId: 'yourNoteActiveTopicId',
    yourNoteActiveNode: 'yourNoteActiveNode',
    yourNoteActiveEntry: 'yourNoteActiveEntry',
    yourDataActiveTopic: 'yourDataActiveTopic',
    yourDataActiveEntry: 'yourDataActiveEntry',
    searchQuery: 'searchQuery',
    searchSelectedRk: 'searchSelectedRk',
    contentHeaderCollapsed: 'contentHeaderCollapsed',
    contentFocusMode: 'contentFocusMode',       // ADDED — hides header + toolbar
    contentFocusBtnPos: 'contentFocusBtnPos',   // ADDED — draggable button position { x, y }
    attachmentStripCollapsed: 'attachmentStripCollapsed', // ADDED — user preference for attachment strip visibility
};
